"use strict";

import React, {Component} from "react";
import {PropTypes, RenderContent} from "Subschema";
import UIPropTypes from "../PropTypes";

export default class ActivationHeader extends Component {
    static propTypes = {
        line1: PropTypes.string,
        warnings: UIPropTypes.notif,
        line2: PropTypes.string,
        style: PropTypes.style
    };

    static injectedProps = {
        warnings: 'global.warning'
    };

    renderWarning = (warning, i) => {
        return warning && warning.message ?
            <span key={`global_warning-p-${i}`} className={this.props.warningClass}>{warning.message}</span> : null;
    };

    render() {
        const {line1, line2, line1Class, line2Class, warnings} = this.props;
        return (line1 || line2 || warnings) ? <div key="activation-header">
                {line1?<span key="line1" className={line1Class}>{line1}</span>:null}
                {warnings && warnings.length > 0 ? warnings.map(this.renderWarning, this) : null}
                {line2?<span key="line2" className={line2Class}>{line2}</span>:null}
            </div>: null;
    }
}


/** WEBPACK FOOTER **
 ** ./src/templates/ActivationHeader.jsx
 **/